export const COLORS = [
  "#ea0530",
  "#43a047",
  "#ff6347",
  "#4c87cd",
  "#f0ad4e",
  "#c532a4",
  "#27d7cc",
];
